/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createSubscriber,
	createContainer,
	type BoundActions,
	type GenericContainerComponent,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import Store, { type Actions } from '../basket.tsx';
import type { State } from '../types.tsx';

// @ts-expect-error - TS2322: iso-decl artefact
export const UserPreferencesSubscriber: SubscriberComponent<
	State,
	// @ts-expect-error - TS2344: generic constraint not satisfied (iso-decl artefact)
	BoundActions<State, typeof import('../actions/index.tsx')>,
	unknown
	// @ts-expect-error - TS2344: generic constraint not satisfied (iso-decl artefact)
> = createSubscriber<State, Actions>(Store, {
	displayName: 'UserPreferencesSubscriber',
});

// @ts-expect-error - TS2344 - Type 'typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services-user-preferences/src/actions/index")' does not satisfy the constraint 'Record<string, ActionThunk<State, typeof import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/src/packages/platform/services-user-preferences/src/actions/index")>>'.
export const UserPreferencesContainer: GenericContainerComponent<unknown> = createContainer(Store);
